const insuranceStatusReducer = (state = '', action) => {
	switch(action.type){
	case 'STATUSINCLUDED':	
		return 'Included';
	case 'STATUSNOTINCLUDED':
		return 'Declined';
	case 'PAYMENTREQUIRED':
		return 'Payment Required';
	default:
		return state;
	}
}

export default insuranceStatusReducer;